module.exports = __webpack_public_path__ + "img/Purpurbracka.05850232.jpg";